hl.mapping{rule: "int", type: "number"}.
hl.mapping{rule: "string", type: "string"}.
hl.mapping{rule: "bool", type: "number"}.
